module.exports = __webpack_public_path__ + "static/img/12.c714811.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/12.png
// module id = gifG
// module chunks = 0